/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideIcon20Regular = forwardRef('DivideIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 5.249a1.249 1.249 0 1 0 0-2.498 1.249 1.249 0 0 0 0 2.498Z" }),
        React.createElement("path", { d: "M2.25 10A.75.75 0 0 1 3 9.25h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M11.248 16a1.249 1.249 0 1 1-2.497 0 1.249 1.249 0 0 1 2.498 0Z" })));
});
